import { render, staticRenderFns } from "./ProxyShoppingCart.vue?vue&type=template&id=544c1196&scoped=true"
import script from "./ProxyShoppingCart.vue?vue&type=script&lang=js"
export * from "./ProxyShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./ProxyShoppingCart.vue?vue&type=style&index=0&id=544c1196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c1196",
  null
  
)

export default component.exports